import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./ui/eleven/eleven.css";
import { applySkin, deviceStorage, readSkin } from "./ui/eleven/skin";
import { readThemeSetting, resolveTheme } from "./ui/sky/scene";
import { applyWindowColor, readWindowColor } from "./ui/jrpg/window-color";
import { browserBackStack } from "./ui/overlay/backStack";
import { startWidgetBridge } from "./platform/widgets";

// Day or night before the first paint, so the PS1 skin never flashes the wrong
// theme. The sky runtime (`shell/SkyBackdrop.tsx`) owns the attribute after this.
try {
  document.documentElement.dataset.skyTheme = resolveTheme(
    readThemeSetting(window.localStorage),
    window.matchMedia("(prefers-color-scheme: dark)").matches,
  );
} catch {
  // Blocked storage or no matchMedia: the runtime sets it on mount.
}
// The JRPG skin's window colour (More → Appearance). Unreadable storage gives the default.
applyWindowColor(readWindowColor((() => {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
})()));

// The chosen skin (Eleven Light by default) from the first paint, sign-in screen included.
applySkin(readSkin(deviceStorage()));

browserBackStack();
startWidgetBridge();

const container = document.getElementById("root");
if (!container) {
  throw new Error('Root element "#root" is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
